import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '@app/core/services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-unsupported',
  templateUrl: './unsupported.component.html',
  styleUrls: ['./unsupported.component.scss']
})
export class UnsupportedComponent implements OnInit {

  browserLanguage = 'en';
  urlAimed: string;
  linkCopied = false;
  fadeOut = false;

  constructor(
    private translateService: TranslateService,
    private clipboardService: ClipboardService,
    private readonly localStorageService: LocalStorageService
  ) {
    this.urlAimed = this.localStorageService.getItem('urlAim');
  }

  ngOnInit() {
    this.browserLanguage = this.translateService.getBrowserLang();
  }

  copyLink(content: string) {
    this.clipboardService.copyFromContent(content);
    this.linkCopied = true;
    this.fadeOut = true;
    setTimeout(() => this.linkCopied = false, 1500);
    setTimeout(() => this.fadeOut = false, 50);
  }

}
